export var ActionLogType;
(function (ActionLogType) {
    ActionLogType["QUEUED"] = "queued";
    ActionLogType["PROCESSING_STARTED"] = "processing_started";
    ActionLogType["PROCESSING_EARLY_EXIT"] = "processing_early_exit";
    ActionLogType["PROCESSING_GOT_LOCK"] = "processing_got_lock";
    ActionLogType["PROCESSING_IRREVERSIBLE_STEP_STARTED"] = "processing_irreversible_step_started";
    ActionLogType["PROCESSING_IRREVERSIBLE_STEP_COMPLETE"] = "processing_irreversible_step_complete";
    /** Action processing deferred to run later */
    ActionLogType["DEFERRED"] = "deferred";
    /** Generic catch all processing ended for easier queries locating crashed processes */
    ActionLogType["PROCESSING_ENDED"] = "processing_ended";
    /** The catch block was triggered, use this to check for failed and still no ended */
    ActionLogType["PROCESSING_FAILED"] = "processing_failed";
})(ActionLogType || (ActionLogType = {}));
//# sourceMappingURL=actionLog.js.map